// src/pages/AdsContent.js
import React, { useEffect, useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AppContext from '../contexts/AppContext';
import Detail from './Detail';

const AdsContent = () => {
  const { selectedRole, token } = useContext(AppContext);
  const location = useLocation();
  const navigate = useNavigate();

  // 1. 优先从 location.state 拿 content（navigate 时传进来的）
  const [contentData, setContentData] = useState(
    location.state?.content || null
  );

  useEffect(() => {
    // 如果已经有 contentData，就跳过 fetch
    if (contentData) return;

    const fetchAdvData = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/private/adv/${selectedRole.id}/content`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await res.json();

        // 写入本地 state
        setContentData(data);

        // 更新 history.state（不改变 URL），让 Detail 能拿到 location.state.content
        navigate(location.pathname, {
          state: { content: data },
          replace: true,
        });
      } catch (err) {
        console.error('Fail to fetch ads data:', err);
      }
    };

    if (selectedRole.id && token) {
      fetchAdvData();
    }
  }, [
    contentData,
    selectedRole.id,
    token,
    navigate,
    location.pathname,
  ]);

  if (!contentData) {
    return <div>Loading…</div>;
  }

  // 直接渲染 Detail，Detail 会优先使用 location.state.content
  return <Detail />;
};

export default AdsContent;
